import { FunctionComponent, useState, useCallback } from 'react'
import { AppCheckbox, AppDropdown, AppButton } from '@/shared/ui'
import { CaretDownIcon } from '@phosphor-icons/react'

import { exist, removeItem } from '../../tools/array-tools'

interface CheckboxChangeValues {
  id: string
  checked: boolean
}

export type Item = {
  label?: string
  value?: string
  color?: string
}

export type DropdownMultiSelectProps = {
  buttonText?: string
  items?: Item[]
  visible?: boolean
  onChangeVisible?: () => void
  selectedItems?: string[]
  onChangeSelectedItems?: (items: string[]) => void
  className?: string
}

export const DropdownMultiSelect: FunctionComponent<DropdownMultiSelectProps> = ({
  buttonText = 'Flotas (Todos)',
  items = [
    {
      label: 'Flota 1',
      value: '1',
      color: '#1890FF'
    },
    {
      label: 'Flota 2',
      value: '2',
      color: '#DE1870'
    }
  ],
  onChangeVisible = () => {},
  visible = false,
  selectedItems = [],
  onChangeSelectedItems = () => {},
  className = ''
}: DropdownMultiSelectProps): JSX.Element => {
  const [, updateState] = useState({})
  const forceUpdate = useCallback(() => updateState({}), [])

  const onChangeCheckbox = (event: any) => {
    const { id, checked }: CheckboxChangeValues = event?.target
    let selection = selectedItems
    if (checked && !exist(selectedItems, String(id))) {
      selection.push(String(id))
    } else {
      selection = removeItem(selection, String(id))
    }
    onChangeSelectedItems(selection)
    forceUpdate()
  }

  const itemsList = (
    <div className='gungnir-dms-items-list'>
      {items.map(({ label, value, color }, idx) => {
        const id = String(value)
        return (
          <AppCheckbox
            onChange={onChangeCheckbox}
            style={color ? { borderLeft: `4px solid ${color}` } : {}}
            key={idx}
            id={id}
            checked={exist(selectedItems, id)}
          >
            {label}
          </AppCheckbox>
        )
      })}
    </div>
  )

  return (
    <div data-testid='gungnir-dms' className={`gungnir-dms ${className}`}>
      <AppDropdown trigger={['click']} open={visible} overlay={itemsList} className='gungnir-dms-dropdown'>
        <AppButton onClick={onChangeVisible}>
          {buttonText}
          <CaretDownIcon />
        </AppButton>
      </AppDropdown>
    </div>
  )
}
